import React from "react";
import getConfig from "next/config";
import Link from "next/link";
import Heading from "@components/Heading";

const {
  publicRuntimeConfig: { settings },
} = getConfig();

const TopArticles = ({ items }) => {
  if (!items || !items.length) {
    return null;
  }

  return (
    <>
      <Heading
        title="Cele mai citite articole de suport"
        as="h2"
        display="h1"
        classesProp="mb-1 lg:mb-2 -tracking-0.5 lg:-tracking-0.67 leading-30 lg:leading-normal"
      />

      <div className="flex flex-wrap -ml-3 overflow-hidden">
        {items.map((item) => (
          <Link
            key={item.title}
            href={`${settings.baseUrl}/suport-clienti/${item.categories[0].slug}/`}
            passHref
          >
            <a
              className="block w-auto ml-3 mt-3 py-10px px-5 rounded-bl-lg rounded-tr-lg
                        bg-white border border-newsletterYellow-dark"
            >
              <span
                className="text-newGray-mildDark text-sm font-medium leading-18.2 -tracking-0.29"
                style={{ marginBottom: "6px" }}
              >
                {item.categories[0].name}
              </span>
              <br></br>
              <span className="leading-20.8">{item.title}</span>
            </a>
          </Link>
        ))}
      </div>
    </>
  );
};

export default TopArticles;
